import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useTheme } from 'ThemeContext';

import {
  Wrapper,
  Text,
  Subtext,
  Link,
  Arrow,
  Image,
  Hr
} from './TitleImages.style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
function Title({
  title = '',
  subtitle = '',
  titleColor = undefined,
  titleBackground = undefined,
  linkBackground = undefined,
  linkColor = undefined,
  linkText = '',
  slug = undefined,
  imageSrc = undefined
}) {
  const theme = useTheme();
  return (
    <Wrapper theme={theme.title.wrapper} titleBackground={titleBackground}>
      <Hr></Hr>
      {imageSrc ? <Image src={imageSrc} alt=''></Image> : ''}
      <Text theme={theme.title.text} titleColor={titleColor}>
        {title}
      </Text>
      {subtitle ? (
        <Subtext theme={theme.title.subtext}>{subtitle}</Subtext>
      ) : (
        ''
      )}
      {slug
        ? // <Link
          //  linkBackground={linkBackground}
          //  linkColor={linkColor}
          //  theme={theme.title.link}
          //  smooth
          //  to={slug && slug[0] === '/' ? slug : `/${slug}`}>
          //  {linkText ? linkText : <FormattedMessage id='TITLE.ALL_ARTICLES' />}
          //  <Arrow theme={theme.title.arrow}>
          //    <FontAwesomeIcon icon={theme.title.arrow.faIcon} />
          //  </Arrow>
          //</Link>
          ''
        : ''}
      <Hr></Hr>
    </Wrapper>
  );
}

export default Title;
